import React from 'react'
import { Cell } from 'rsuite-table'
import { LANGUAGE } from '../../../../pages/template/utils'

type DateTimeCellProps = {
  rowData?: any,
  dataKey: string,
  onCellClick?: (rowData: any) => void
}

const languageMap = Object.entries(LANGUAGE).reduce(
  (acc, [fullName, code]) => ({ ...acc, [code]: fullName.replace('_', ' ') }),
  {} as Record<string, string>
)

const LanguageCell: React.FC<DateTimeCellProps> = ({
  rowData,
  dataKey,
  onCellClick,
  ...props
}) => {
  const languageCode = rowData?.[dataKey] ?? null
  const languageFullName = languageCode
    ? languageMap[languageCode] || 'Unknown'
    : '-'

  return (
    <Cell
      {...props}
      onClick={() => {
        if (onCellClick) {
          onCellClick(rowData)
        }
      }}
    >
      {languageFullName}
    </Cell>
  )
}

export default LanguageCell
